import { Box, Typography } from '@material-ui/core';
import { Link } from '@backstage/core-components';

export const ScaffolderGroupTitleMachX = () => {
  return (
    <Box>
      <Typography variant="h4">
        Create a New Project with Threads Templates (machx)
      </Typography>
      <Typography paragraph>
        Start your journey to create the next sustainable, secure, and cost
        conscious software product at H&M. Learn more on{' '}
        <Link to="/docs/default/system/machx">machx documentation</Link>.
      </Typography>
    </Box>
  );
};
